enum Features {
  TREATMENT_PLAN = 'TreatmentPlan',
  TOXICOLOGY = 'Toxicology',
  BIDIRECTIONAL = 'BiDirectionalVisitNote',
  DOCUMENTS = 'Documents',
  OPEN_AI = 'OpenAi',
  DAYLY_DOWNLOAD = 'DailyDownload',
  AI_ASSIST = 'AiAssist',
}

export const featureLabels: { [key: string]: string } = {
  [Features.TREATMENT_PLAN]: 'Treatment Plan',
  [Features.TOXICOLOGY]: 'Toxicology',
  [Features.BIDIRECTIONAL]: 'Bidirectional',
  [Features.DOCUMENTS]: 'Documents',
  [Features.OPEN_AI]: 'Mobile AI Assist',
  [Features.DAYLY_DOWNLOAD]: 'Daily Download',
  [Features.AI_ASSIST]: 'Web AI Assist',
};

export const featureList = [
  Features.TREATMENT_PLAN,
  Features.TOXICOLOGY,
  Features.BIDIRECTIONAL,
  Features.DOCUMENTS,
  Features.OPEN_AI,
  Features.DAYLY_DOWNLOAD,
  Features.AI_ASSIST,
];

export default Features;
